var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')

var Enums = function () {

  // init
  var Enum = BaseModel.extend({
    urlRoot: Config.api.host + '/enums'
  })

  // //
  var API = {
    getEnums: function (callback) {
      var enums = new Enum()
      enums.fetch()
      return enums
    // var clients = new ClientsCollection()
    // clients.fetch({
    //   reset: true
    // })
    // return clients
    },
    getClientEntity: function (id) {
      var client = new Client({_id: id})
      client.fetch()
      return client
    },
    newClientEntity: function () {
      return new Client()
    },
    initialize: function (callback) {
      var enums = new Enum()
      enums.fetch({
        reset: true,
        success: function () {
          return callback(null)
        },
        error: function () {
          return callback(new Error('Something'))
        }
      })
      App.entities.enums = enums
    // App.enums = globalChannel.request('enums:entity')
    // App.enums.on('change', function () {
    // })
    }
  }

  API.getEnums()

  App.globalChannel.reply({
    'enums:entity': API.getEnums
  })

  return API
//
}

module.exports = Enums



// WEBPACK FOOTER //
// ./js/entities/enums.js